import {Icon, Layout, Spacer, Text} from '@di-nxt/components';
import React, {useCallback} from 'react';
import {useAppNavigationContext} from '../../navigation/hooks';

type Props = {
  title?: string;
  subtitle?: string;
};

export const SceneHeader: React.FC<Props> = ({
  title = '',
  subtitle,
  children,
}) => {
  const {setSidebarVisible} = useAppNavigationContext();
  const handleToggleSidebar = useCallback(() => setSidebarVisible(p => !p), [
    setSidebarVisible,
  ]);

  return (
    <>
      <Layout
        vertical
        justify="center"
        paddingHorizontal="20"
        paddingVertical="16"
        borderBottomColor="border_mono_15"
        borderBottomWidth="1"
        borderBottomStyle="solid">
        <Layout horizontal align="center" justify="space-between">
          <Layout horizontal centered>
            <Layout
              hideWhen={['desktop', 'tablet']}
              padding="2"
              onPress={handleToggleSidebar}>
              <Icon name="menu" size="24" />
              <Spacer width="16" />
            </Layout>
            <Layout vertical>
              <Text variant="inline_16_emphasis">{title}</Text>
              {subtitle ? (
                <>
                  <Spacer height="2" />
                  <Text variant="inline_12_default">{subtitle}</Text>
                </>
              ) : null}
              <Spacer width="2" />
            </Layout>
          </Layout>
          {children}
        </Layout>
      </Layout>
    </>
  );
};
